export enum ProductRelationHierarchy {
  Parent = 'parent',
  Child = 'child',
  Sibling = 'sibling'
}
